import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  FeeApproveReject,
  // GetAvailableRoom,
  // GetBedMasterById,
  // GetClassMaster,
  GetFeeAppPendingList,
  // GetRoomMaster,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const HostelFeeAppPendingList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  // const [allotModalOpen, setAllotModalOpen] = useState(false)
  // const [rooms, setRooms] = useState([])
  // const [beds, setBeds] = useState([])
  // const [selectedRoomId, setSelectedRoomId] = useState(null)
  // const [selectedBedId, setSelectedBedId] = useState(null)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  // const [classes, setClasses] = useState([])
  // const [selectedClassId, setSelectedClassId] = useState(null)

  useEffect(() => {
    fetchFeeAppPendingList()
  }, [])

  // const fetchClasses = async () => {
  //   try {
  //     const res = await axios.get(`${GetClassMaster}/${storedBranchId}`)
  //     setClasses(res.data)
  //   } catch (err) {
  //     toast.error('Failed to load classes')
  //   }
  // }

  // const fetchRooms = async (classId) => {
  //   try {
  //     const res = await axios.get(`${GetAvailableRoom}/${classId}`)

  //     if (Array.isArray(res.data)) {
  //       setRooms(res.data)
  //     } else {
  //       setRooms([]) // prevent crash
  //       if (res.data === 'NO_ROOMS_FOUND') {
  //         toast.warning('No rooms available for selected class')
  //       }
  //     }
  //   } catch (err) {
  //     toast.error('Failed to load rooms')
  //     setRooms([]) // safety
  //   }
  // }

  // const fetchBeds = async (roomId) => {
  //   try {
  //     const res = await axios.get(
  //       `${GetBedMasterById}/${storedBranchId}/${roomId}`,
  //     )
  //     setBeds(res.data)
  //   } catch (err) {
  //     toast.error('Failed to load beds')
  //   }
  // }

  const fetchFeeAppPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetFeeAppPendingList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        hostel_tax_id: item.payment?.hostel_tax_id ?? '-',
        hostel_pay_amount : item.payment?.hostel_pay_amount ?? '-',
       

        //  Correct date format (YYYY-MM-DD)
        hostel_pay_date: item.payment?.hostel_pay_date
          ? new Date(item.payment.hostel_pay_date).toISOString().split('T')[0]
          : '-',
        hostel_pay_mode:
          item.payment.hostel_pay_mode == 1
            ? 'Cash'
            : item.payment.hostel_pay_mode == 2
            ? 'UPI'
            : 'Online',
        full_data: item,
      }))

      console.log(res.data);

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.hostel_tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Tax ID', dataIndex: 'hostel_tax_id' },
    { title: 'Amount', dataIndex: 'hostel_pay_amount' },
    { title: 'Pay Date', dataIndex: 'hostel_pay_date' },
    { title: 'Pay Mode', dataIndex: 'hostel_pay_mode' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const handleApproval = async (type) => {
    if (!selectedRecord) return

    const today = new Date().toISOString().split('T')[0]
    const approvalValue = type === 'approve' ? 2 : 3

    const body = {
      reg_id: parseInt(selectedRecord.reg_id),
      branch_id: parseInt(selectedRecord.branch_id),
      // class_id: parseInt(selectedClassId),

      // // 👉 Use selected room/bed from allocation modal
      // room_id: parseInt(selectedRoomId),
      // bed_id: parseInt(selectedBedId),
      // year: parseInt(BoardingYear),

      hostelPay_approval: approvalValue,
      // hostelPay_approval_date: today,
      ...(approvalValue === 2 && { hostelPay_approval_date: today }),
    }

    try {
      setLoading(true)
      const res = await axios.put(FeeApproveReject, body)

      if (res.data === 'APPROVED') {
        toast.success(
          approvalValue === 2
            ? 'Application Approved Successfully'
            : 'Application Rejected Successfully',
        )
        setConfirmChecked(false)
        setViewModalOpen(false)
        // setAllotModalOpen(false)
        // setSelectedRoomId(null)
        // setSelectedBedId(null)
        fetchFeeAppPendingList()
  
      } else if (res.data == 'ERROR') {
        toast.warn('Some error occurred! Please try again later')
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading(false)
    }
  }

  const handleRejectSubmit = async () => {
    if (!selectedRecord) return

    const body = {
      reg_id: parseInt(selectedRecord.reg_id),
      hostelPay_approval: 3,
      hostelPay_reject_reason: rejectReason.trim(),
    }

    try {
      setLoading(true)
      const res = await axios.put(FeeApproveReject, body)

      toast.success('Application Rejected Successfully')

      // Reset all states
      setRejectModalOpen(false)
      setRejectReason('')
      setConfirmChecked(false)
      setSelectedRecord(null)

      fetchFeeAppPendingList()
    } catch (err) {
      toast.error('Failed to reject application')
    } finally {
      setLoading(false)
    }
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
      'Tax ID': item.hostel_tax_id,
      'Amount' : item.hostel_pay_amount,
      'Pay Date': item.hostel_pay_date,
      'Pay Mode': item.hostel_pay_mode,
    }))
    
    
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
    ]

    // const excelData = filteredData.map((item) => {
    //   const student = { ...item.full_data }

    //   // Flatten nested objects
    //   student.admin = student.admin?.username || ''
    //   student.documents = JSON.stringify(student.documents || {})

    //   return student
    // })

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Hostel Fee Approval Pending',
    )

    XLSX.writeFile(workbook, 'Hostel_Fee_Approval_Pending_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Hostel Fee Approval Pending List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ========= ACADEMIC INFORMATION ========== */}
              <h6 style={titleText}>- Academic Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Name of School / College Last Attended:
                    </span>
                    <br /> {selectedRecord.last_attended_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Highest Qualification Obtained:
                    </span>
                    <br /> {selectedRecord.highest_qualification}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Specific Degree:</span>
                    <br /> {selectedRecord.specific_degree}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Aggregate Percentage (%):</span>
                    <br /> {selectedRecord.aggre_percentage}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Month & Year of Passing:</span>
                    <br /> {selectedRecord.month_year_of_passing}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Name of Institution Currently Enrolled In:
                    </span>
                    <br /> {selectedRecord.curr_yr_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Course / Program Name:</span>
                    <br /> {selectedRecord.course_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Course Duration:</span>
                    <br /> {selectedRecord.total_course_duration}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Remaining Duration of Course:</span>
                    <br /> {selectedRecord.remaining_course_duration}
                  </div>
                </div>
              </div>

              {/* ========= FAMILY INFORMATION ========== */}
              <h6 style={titleText}>- Family Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                {/* =======FATHER INFO======= */}
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Name:</span>
                    <br />
                    {selectedRecord.father_fname} {selectedRecord.father_mname}{' '}
                    {selectedRecord.father_lname}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Mobile No.:</span>
                    <br /> {selectedRecord.father_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Age:</span>
                    <br /> {selectedRecord.father_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Occupation:</span>
                    <br /> {selectedRecord.father_occ}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Family Members:</span>
                    <br /> {selectedRecord.total_family_mamber}
                  </div>
                </div>
                {/* =======MOTHER INFO======= */}
                <div className="row">
                  <div
                    className="col-12 m-0 p-0 mb-3"
                    style={{ borderTop: '1px solid #d2d2d2ff' }}
                  ></div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Name:</span>
                    <br />
                    {selectedRecord.mother_fname} {selectedRecord.mother_mname}{' '}
                    {selectedRecord.mother_lname}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Mobile No.:</span>
                    <br /> {selectedRecord.mother_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Age:</span>
                    <br /> {selectedRecord.mother_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Occupation:</span>
                    <br /> {selectedRecord.mother_occ}
                  </div>
                </div>

                {/* =======EMERGENCY INFO======= */}
                <div className="row">
                  <div
                    className="col-12 m-0 p-0 mb-3"
                    style={{ borderTop: '1px solid #d2d2d2ff' }}
                  ></div>

                  <div className="col-md-6 col-lg-4 mb-3">
                    <span style={labelCss}>Emergency Contact Name:</span>
                    <br />
                    {selectedRecord.emergency_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Mobile No.:</span>
                    <br /> {selectedRecord.emergency_contact}
                  </div>
                </div>
              </div>

              {/* ========= ADDITIONAL INFORMATION ========== */}
              <h6 style={titleText}>- Additional Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Name:</span>
                    <br /> {selectedRecord?.chairman_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Village:</span>
                    <br /> {selectedRecord?.chairman_village}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Mobile:</span>
                    <br /> {selectedRecord?.chairman_mob}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Name:</span>
                    <br /> {selectedRecord?.reference_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Relation:</span>
                    <br /> {selectedRecord?.reference_relation}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Mobile:</span>
                    <br /> {selectedRecord?.reference_mobile}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Name:</span>
                    <br /> {selectedRecord?.local_guardian_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Address:</span>
                    <br /> {selectedRecord?.local_guardian_address}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Mobile:</span>
                    <br /> {selectedRecord?.local_guardian_mobile}
                  </div>
                </div>
              </div>

              {/* ========= PAYMENT INFORMATION ========== */}
              <h6 style={titleText}>- Payment Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Tax ID:</span>
                    <br /> {selectedRecord.payment?.hostel_tax_id}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Payment Date:</span>
                    <br />
                    {/* {selectedRecord.payment?.register_pay_date?.split("T")[0]} */}
                    {selectedRecord.payment?.hostel_pay_date
                      ? new Date(selectedRecord.payment.hostel_pay_date)
                          .toISOString()
                          .split('T')[0]
                      : '-'}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Fee Amount:</span>
                    <br />{' '}
                    <span
                      className="px-2"
                      style={{ backgroundColor: 'yellow' }}
                    >
                      ₹ {selectedRecord.payment?.hostel_pay_amount}
                    </span>
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Concession Amount:</span>
                    <br />{' '}
                    <span
                      className="px-2"
                      style={{ backgroundColor: 'yellow' }}
                    >
                      ₹ {selectedRecord.concession?.concession_amount || '0'}
                    </span>
                  </div>
                  <div className="col-md-8 mb-3">
                    <span style={labelCss}>Concession Remark:</span>
                    <br /> {selectedRecord.concession?.concession_remark || '-'}
                  </div>
                </div>
              </div>

              {/* ========= UPLOADED DOCUMENTS ========== */}
              <>
                <h6 style={titleText}>- Uploaded Documents :</h6>
                {/* <div className="row text-center">
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Aadhar Card</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_aadhar}`}
                      alt="Aadhar Card"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Hostel Fee Receipt</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.payment.hostel_tax_image}`}
                      alt="Hostel Fee Receipt"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">10th / 12th Leaving Certificate</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.cast_income_cert}`}
                      alt="10th / 12th Leaving Certificate"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Recommendation Letter</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.recommendation_letter}`}
                      alt="Recommendation Letter"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">
                      College Admission Receipt
                    </p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.clg_add_receipt}`}
                      alt="College Admission Receipt"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                </div> */}

                <div className="card shadow-sm p-4 mb-4">
                  <h5 className="mb-3" style={{ color: '#235784' }}>
                    Documents -
                  </h5>

                  <div className="row text-center">
                    {Object.entries({
                      'Aadhar Card': selectedRecord?.documents?.s_aadhar,
                      'Hostel Fee Receipt':
                        selectedRecord?.payment?.hostel_tax_image,
                      '10th / 12th Leaving Certificate':
                        selectedRecord?.documents?.cast_income_cert,
                      'Recommendation Letter':
                        selectedRecord?.documents?.recommendation_letter,
                      'College Admission Receipt':
                        selectedRecord?.documents?.clg_add_receipt,
                    }).map(([label, fileName]) => {
                      const imgSrc = fileName ? IMG_BASE_URL + fileName : null

                      return (
                        <div
                          className="col-12 col-md-6 col-lg-4 mb-3 mt-3 pb-4"
                          style={{ border: '1px solid #b8b8b8ff' }}
                          key={label}
                        >
                          <p className="fw-semibold mb-1">{label}</p>

                          {imgSrc ? (
                            fileName.toLowerCase().endsWith('.pdf') ? (
                              <iframe
                                src={imgSrc}
                                title={label}
                                width="100%"
                                height="300px"
                                style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '6px',
                                }}
                              />
                            ) : (
                              <img
                                src={imgSrc}
                                alt={label}
                                className="img-fluid rounded border"
                                style={{
                                  width: '100%',
                                  objectFit: 'contain',
                                  display: 'block',
                                }}
                              />
                            )
                          ) : (
                            <p className="text-muted">No File</p>
                          )}

                          {imgSrc && fileName.toLowerCase().endsWith('.pdf') && (
                            <a
                              href={imgSrc}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-primary mt-2"
                            >
                              Download PDF
                            </a>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </>
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  className="addButton"
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => {
                    handleApproval("approve")
                    // setViewModalOpen(false)
                    // // setAllotModalOpen(true)
                    // setConfirmChecked(false)
                    // fetchClasses()
                  }}
                >
                  Approve
                </Button>

                <Button
                  danger
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => {
                    setRejectModalOpen(true)
                    setViewModalOpen(false)
                    setConfirmChecked(false)
                  }}
                >
                  Reject
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>

    
      {/* =================== REJECT REASON MODAL =================== */}
      <Modal
        className="reject-reason-modal"
        title={false}
        open={rejectModalOpen}
        onCancel={() => {
          setRejectModalOpen(false)
          setRejectReason('')
        }}
        footer={null}
        centered
      >
        <div className="reject-modal-header">
          <h3>Enter Rejection Reason</h3>
        </div>

        <div className="reject-modal-body">
          <label className="reject-label">Reason for Rejection:</label>
          <textarea
            className="reject-textarea"
            rows={4}
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Enter reason..."
          ></textarea>
        </div>

        <div className="reject-modal-footer">
          <Button
            danger
            type="primary"
            className="reject-submit-btn"
            disabled={!rejectReason.trim()}
            onClick={handleRejectSubmit}
          >
            Submit
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default HostelFeeAppPendingList
